import React from 'react';
import { GlobeIcon, MicIcon, Volume2Icon, ArchiveIcon } from 'lucide-react';
export function ServicesSection() {
  return <section className="w-full bg-white py-20 px-4" id="services" data-id="element-127">
      <div className="max-w-7xl mx-auto" data-id="element-128">
        {/* Headings */}
        <div className="text-center mb-12" data-id="element-129">
          <h2 className="font-bold text-4xl" style={{
          color: '#1B2A4A'
        }} data-id="element-130">
            Our Services
          </h2>
          <p className="text-gray-500 text-base mt-3" data-id="element-131">
            Comprehensive language and media solutions tailored to your needs
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-132">
          {/* Card 1 */}
          <div className="flex flex-col rounded-xl p-6 shadow-sm border border-gray-100" style={{
          backgroundColor: '#F5F6FA'
        }} data-id="element-133">
            <GlobeIcon className="w-10 h-10" style={{
            color: '#2DA5A0'
          }} aria-hidden="true" data-id="element-134" />
            <h3 className="font-bold text-xl mt-4" style={{
            color: '#1B2A4A'
          }} data-id="element-135">
              Translation Services
            </h3>
            <p className="text-sm mt-2 flex-1 leading-relaxed" style={{
            color: '#1E1E1E'
          }} data-id="element-136">
              Flawless translations in 100+ languages that bridge communication
              gaps and expand your reach.
            </p>
            <a href="#" className="text-sm font-medium mt-4 transition-opacity hover:opacity-75" style={{
            color: '#2DA5A0'
          }} data-id="element-137">
              Learn More →
            </a>
          </div>

          {/* Card 2 */}
          <div className="flex flex-col rounded-xl p-6 shadow-sm border border-gray-100" style={{
          backgroundColor: '#F5F6FA'
        }} data-id="element-138">
            <MicIcon className="w-10 h-10" style={{
            color: '#2DA5A0'
          }} aria-hidden="true" data-id="element-139" />
            <h3 className="font-bold text-xl mt-4" style={{
            color: '#1B2A4A'
          }} data-id="element-140">
              Transcription Services
            </h3>
            <p className="text-sm mt-2 flex-1 leading-relaxed" style={{
            color: '#1E1E1E'
          }} data-id="element-141">
              Convert audio and video into precise written content. Medical,
              legal, and general transcription.
            </p>
            <a href="#" className="text-sm font-medium mt-4 transition-opacity hover:opacity-75" style={{
            color: '#2DA5A0'
          }} data-id="element-142">
              Learn More →
            </a>
          </div>

          {/* Card 3 */}
          <div className="flex flex-col rounded-xl p-6 shadow-sm border border-gray-100" style={{
          backgroundColor: '#F5F6FA'
        }} data-id="element-143">
            <Volume2Icon className="w-10 h-10" style={{
            color: '#2DA5A0'
          }} aria-hidden="true" data-id="element-144" />
            <h3 className="font-bold text-xl mt-4" style={{
            color: '#1B2A4A'
          }} data-id="element-145">
              Audio / Visual Services
            </h3>
            <p className="text-sm mt-2 flex-1 leading-relaxed" style={{
            color: '#1E1E1E'
          }} data-id="element-146">
              Enhance your multimedia content with professional audio and visual
              production services.
            </p>
            <a href="#" className="text-sm font-medium mt-4 transition-opacity hover:opacity-75" style={{
            color: '#2DA5A0'
          }} data-id="element-147">
              Learn More →
            </a>
          </div>

          {/* Card 4 */}
          <div className="flex flex-col rounded-xl p-6 shadow-sm border border-gray-100" style={{
          backgroundColor: '#F5F6FA'
        }} data-id="element-148">
            <ArchiveIcon className="w-10 h-10" style={{
            color: '#2DA5A0'
          }} aria-hidden="true" data-id="element-149" />
            <h3 className="font-bold text-xl mt-4" style={{
            color: '#1B2A4A'
          }} data-id="element-150">
              Digitization of Media
            </h3>
            <p className="text-sm mt-2 flex-1 leading-relaxed" style={{
            color: '#1E1E1E'
          }} data-id="element-151">
              Preserve valuable media assets with professional digitization for
              long-lasting accessibility.
            </p>
            <a href="#" className="text-sm font-medium mt-4 transition-opacity hover:opacity-75" style={{
            color: '#2DA5A0'
          }} data-id="element-152">
              Learn More →
            </a>
          </div>
        </div>
      </div>
    </section>;
}